import { AppError } from '@profile/src/redux/types';
export function parseLocation(location) {
  const {
    redirectTo,
    backTo
  } = location || {};
  return {
    redirectTo: typeof redirectTo === 'string' ? redirectTo : undefined,
    backTo: typeof backTo === 'string' ? backTo : undefined
  };
}
export function formatErrorMessage(error) {
  switch (error) {
    case AppError.UNNKOWN:
      return 'Something went wrong.\nPlease try again later.';

    case AppError.ABORTED_BY_USER:
      return 'User Rejected the Signature Request';

    case AppError.ADDRESS_EXIST:
      return 'This account has linked to an address already';

    case AppError.SIGNATURE_INVALID:
      return 'Invalid user signature verification';

    case AppError.EMAIL_EXIST:
      return 'This email is invalid or already connected to another wallet';

    case AppError.EMAIL_NOT_EXIST:
      return 'This email is invalid or already connected to another wallet';

    case AppError.EMAIL_INVALID:
      return 'Invalid email. Please try again';

    case AppError.CODE_INVALID:
      return 'Invalid code. Please try again';

    case AppError.ACCOUNT_HAS_BEEN_LINKED:
      return 'This account has linked to an address already';

    case AppError.INCORRECT_USER_ID:
      return 'User call verify incorrect or call register first';

    case AppError.USER_BANNED:
      return 'Your game account has been banned.';

    default:
      return 'Something error happened try again later';
  }
}
export function setCountDownSendCode(dateNow) {
  localStorage.setItem('sendCodeTimestamp', dateNow);
}
export function removeCountDownSendCode() {
  localStorage.removeItem('sendCodeTimestamp');
}
export const openInNewTab = (url, shouldOpenNewTab = true) => {
  shouldOpenNewTab ? window.open(url, '_blank') : window.location.href = url;
};
export const parseFeatureToggleObject = key => {
  try {
    const result = JSON.parse(key);
    return result;
  } catch (error) {
    return undefined;
  }
};
export const checkRecommended = config => {
  if (!config) {
    return false;
  }

  const now = Date.now() / 1000;

  if (config.startTime <= now && now <= config.endTime) {
    return true;
  }

  return false;
};